import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IPC_CHANNEL } from "../../_offline/electron.constants";
import { SubjectModelLocationsSchema } from "../../_offline/models/subjectModel-locations.schema";
import { DatabaseBaseService } from "../base/database-base.service";
import { LoginUserOfflineService } from "../offline/login-user-offline.service";
import { ElectronService } from "../../electron.service";

@Injectable({
  providedIn: "root"
})
export class SubjectModelLocationsDbService extends DatabaseBaseService {
  constructor(
    protected electronService: ElectronService,
    protected loginUserService: LoginUserOfflineService
  ) {
    super(electronService, loginUserService);
  }

  getAll(): Observable<SubjectModelLocationsSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.SUBJECT_MODEL_LOCATIONS.GET_ALL);
  }

  putAll(subjectModelLocations: SubjectModelLocationsSchema[]): Observable<SubjectModelLocationsSchema[]> {
    return this.ipcSendSync(IPC_CHANNEL.SUBJECT_MODEL_LOCATIONS.PUT_ALL, subjectModelLocations);
  }

  getOne(id: string): Observable<SubjectModelLocationsSchema> {
    return this.ipcSendSync(IPC_CHANNEL.SUBJECT_MODEL_LOCATIONS.GET_ONE, this.tenantId, id);
  }

  async getOneByInspectionId(id: string): Promise<SubjectModelLocationsSchema> {
    return await this.electronService.invoke(IPC_CHANNEL.SUBJECT_MODEL_LOCATIONS.GET_ONE_BY_INSPECTION_ID, this.tenantId, id);
  }
}
